import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/api';
import { AuthService } from 'src/app/admihair/service/auth.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { UsuarioService } from '../../service/usuario.service';
import { ErroService } from '../../service/erro.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Usuario } from '../../api/dto/usuario';
import { NgForm } from '@angular/forms';
import { InputMask } from 'primeng/inputmask';
import { UtilStorageService } from '../../service/util-storage.service';

@Component({
	templateUrl: './primeiro-acesso.component.html'
})
export class PrimeiroAcessoComponent implements OnInit {

	id?: number;
	messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }];
	messagemVisivel: boolean = false;
	usuario: Usuario = {};
	senha: string = '';
	senhaConfirmada: string = '';
	tipoLogin: String = 'EMAIL';


	constructor(private layoutService: LayoutService,
		private usuarioService: UsuarioService,
		private erroService: ErroService,
		private _router: Router,
		private utilStorageService: UtilStorageService,
		private _activatedRoute: ActivatedRoute) { }

	ngOnInit(): void {
		this.carregarIdUsuario();
		this.buscarUsuarioPorId();
	}

	buscarUsuarioPorId() {
		this.usuarioService.buscarPorId(this.id).subscribe({
			next: (data: Usuario) => {
				console.log(this.id);
				this.usuario = data;
			}
		})
	}

	atualizar() {
		
		if (!this.usuario.apelido) {
			this.usuario.apelido = this.usuario.nome;
		}

		this.usuario.primeiroAcesso = false;

		if(this.senha === this.senhaConfirmada){	
			this.usuario.senha = this.senha;
		}else{
			this.messages =  [{ severity: 'warn', summary: 'Atenção', detail: 'Senha não connfere.' }];
			this.messagemVisivel = true;
			this.rolarTela();
		}

		
		this.usuarioService.atualizarPrimeiroAcesso(this.id, this.usuario).subscribe({
			next: () => {
				this.logout();
				this.irParaLogin();
			},
			error: (err: any) => {
				this.messages = this.erroService.handleErro(err);
				this.messagemVisivel = true;
			}
		})

	}

	definirTipoLogin(){
		switch (this.tipoLogin) {
			case 'TELEFONE':
				this.usuario.login = this.usuario.whatsapp;
				break;
			case 'EMAIL':
				this.usuario.login = this.usuario.email;
				break;
			case 'OUTRO':
				this.usuario.login = '';
				break;
		}
	}


	transformarCpf(cpf?: string): string {
		console.log('ok')
		if (!cpf) {
		  return '';
		}
	
		// Remove caracteres não numéricos do valor
		const numericValue = cpf.replace(/\D/g, '');
	
		// Aplica a máscara do CPF (999.999.999-99)
		this.usuario.cpf =  numericValue.replace(
		  /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
		  '$1.$2.$3-$4'
		);
		return '';
	  }

	  transformarTelefone(telefone?: string): string {
		console.log('ok');
		if (!telefone) {
			return '';
		}
	
		// Remove caracteres não numéricos do valor
		const numericValue = telefone.replace(/\D/g, '');
	
		// Aplica a máscara de telefone (99)99999-9999
		this.usuario.whatsapp = numericValue.replace(
			/^(\d{2})(\d{5})(\d{4})$/,
			'($1) $2-$3'
		);
	
		return '';
	}

	formatarApelido(nome?: string): string {
		return nome !== undefined ? nome.split(' ')[0] : '';
	}

	carregarIdUsuario() {
		const idParam = this._activatedRoute.snapshot.paramMap.get('id');
		if (idParam) {
			this.id = parseInt(idParam);
		}
	}


	irParaLogin() {
		this._router.navigate(["/auth/login"], { relativeTo: this._activatedRoute })
	}


	get dark(): boolean {
		return this.layoutService.config.colorScheme !== 'light';
	}

	rolarTela(){
		window.scroll({
		  top: 0,
		  left: 0,
		  behavior: 'smooth'
		});
	  }

	  logout(): void {
		this.utilStorageService.signOut();
		this._router.navigate(["/auth/login"],{relativeTo:this._activatedRoute})
	  }
}
